import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import api from 'api';
import { query } from 'redux-bees';
import { Link } from 'react-router-dom';
import Log from 'components/Log';

@query('deploy', api.getDeploy, (perform, { match: { params } }) => (
  perform({ siteId: params.siteId, id: params.id })
))
@query('log', api.getDeployLog, (perform, { match: { params } }) => (
  perform({ siteId: params.siteId, id: params.id })
))

export default class Deploys extends Component {
  static propTypes = {
    deploy: PropTypes.object,
    log: PropTypes.object,
    match: PropTypes.object,
  }

  render() {
    const { log, deploy, match } = this.props;

    return (
      <Log
        log={log && log.attributes.content}
        pending={deploy && (deploy.attributes.state === 'in_progress' || deploy.attributes.state === 'publishing')}
      >
        <Link
          to={`/site/${match.params.siteId}/deploys`}
        >
          Go back to deploys
        </Link>
      </Log>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Deploy.jsx